import { Injectable } from '@angular/core';
import { PagedResult, User } from '@interfaces';
import { Apollo } from 'apollo-angular';
import { Queries } from './queries';

@Injectable({
  providedIn: 'root'
})
export class PendenciesService {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
  ) {}

  async getPendencies(options): Promise<PagedResult> {
    return this.apollo
      .query({
        query: this.queries.getPendencies(),
        variables: options
      })
      .toPromise()
      .then((response) => response.data['pendencies']);
  }
}
